/** @jsx jsx */
import React from 'react';
import { jsx, css } from '@compiled/react';
import Placeholder from '@atlaskit/react-ufo/placeholder';
import { token } from '@atlaskit/tokens';

import { fg } from '@atlassian/jira-feature-gating';
import ReplyEditorContainer from './replies-editor-wrapper/index.tsx';

type CommentRepliesContainerProps = {
	fullIssueUrl: string | null;
	commentId: string;
	commentSessionId?: string | null;
	hasReplies: boolean;
	isRealTimeCommentUpdated?: boolean;
};

const LazyRepliesList = importCond<
	typeof import('./replies-list/index.tsx'),
	typeof import('./replies-list/async.tsx')
>('issue_comment_reply_list_sync_import', './replies-list/index.tsx', './replies-list/async.tsx');

const RepliesContainer = ({ hasReplies, ...otherProps }: CommentRepliesContainerProps) => {
	return (
		<div
			css={[
				fg('jira_custom_comment_component_refactor')
					? sectionContainerWithCustomComponentStyle
					: sectionContainerStyle,
			]}
		>
			{hasReplies && (
				<Placeholder name="reply-comments-list">
					<LazyRepliesList {...otherProps} />
				</Placeholder>
			)}
			<ReplyEditorContainer {...otherProps} />
		</div>
	);
};

const sectionContainerStyle = css({
	marginTop: token('space.negative.400'),
});
const sectionContainerWithCustomComponentStyle = css({
	marginTop: token('space.050'),
});
export default RepliesContainer;
